"use strict";
import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
var test = {
    foo: {}
};
var $Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: test
    }).foo === test.foo && !_instanceof({
        __proto__: null
    }, $Object);
};
